// @ts-nocheck
import { push } from '@scale/frontend-lib/link';
import cache from './client-cache';
import apiFetch, { defaultApiFetchErrorHandler } from './api-fetch';
import { terminateClientSession } from '@scale/shared/outlier/sessions/index';
import {
  logSessionTerminateEvent,
  logSessionUserLogout,
} from 'react-scale/lib/analytics/session-analytics';

const logout = async redirectUrl => {
  try {
    await apiFetch(null, 'internal/logout');
    logoutUserLeap();
  } catch (err) {
    defaultApiFetchErrorHandler(err, { handleHttp: true });
  }

  cache.flush();

  void logSessionTerminateEvent();
  void logSessionUserLogout();
  terminateClientSession();

  push(redirectUrl);
};

export default logout;

export const logoutAndRefresh = async redirectUrl => {
  try {
    await apiFetch(null, 'internal/logout');
    logoutUserLeap();
  } catch (err) {
    defaultApiFetchErrorHandler(err, { handleHttp: true });
  }

  cache.flush();

  void logSessionTerminateEvent();
  void logSessionUserLogout();
  terminateClientSession();

  window.location.href = redirectUrl;
};

// NOTE: used in Remotasks
const logoutUserLeap = () => {
  if (window.UserLeap && UserLeap && UserLeap.logoutUser) {
    UserLeap.logoutUser();
  }
};
